export const getStatusStyle = (status) => {
  switch (status) {
    case "PENDING_PICKUP":
    case "FILLING":
      return {
        backgroundColor: "hsl(60, 100%, 90%)",
        borderColor: "hsl(60, 100%, 35%)",
        color: "hsl(60, 100%, 25%)",
      };
    case "PICKUP_IN_PROGRESS":
    case "FILLED":
    case "ONGOING":
    case "DEPARTED":
      return {
        backgroundColor: "hsl(60, 100%, 85%)",
        borderColor: "hsl(60, 100%, 35%)",
        color: "hsl(60, 100%, 25%)",
      };
    case "PICKED_UP":
      return {
        backgroundColor: "hsl(60, 100%, 80%)",
        borderColor: "hsl(60, 100%, 30%)",
        color: "hsl(60, 100%, 20%)",
      };
    case "PENDING_DROP_OFF":
      return {
        backgroundColor: "hsl(270, 100%, 90%)",
        borderColor: "hsl(270, 100%, 50%)",
        color: "hsl(270, 100%, 40%)",
      };
    case "DROP_OFF_IN_PROGRESS":
      return {
        backgroundColor: "hsl(270, 100%, 85%)",
        borderColor: "hsl(270, 100%, 45%)",
        color: "hsl(270, 100%, 35%)",
      };
    case "DROPPED_OFF":
      return {
        backgroundColor: "hsl(270, 100%, 80%)",
        borderColor: "hsl(270, 100%, 40%)",
        color: "hsl(270, 100%, 30%)",
      };
    case "IN_BOX":
      return {
        backgroundColor: "hsl(230, 100%, 95%)",
        borderColor: "hsl(230, 100%, 55%)",
        color: "hsl(230, 100%, 45%)",
      };
    case "IN_TROLLEY":
      return {
        backgroundColor: "hsl(270, 100%, 90%)",
        borderColor: "hsl(270, 100%, 40%)",
        color: "hsl(270, 100%, 30%)",
      };
    case "DELIVERED":
    case "LOADING":
    case "COMPLETED":
    case "ARRIVED":
      return {
        backgroundColor: "hsl(115, 100%, 85%)",
        borderColor: "hsl(115, 100%, 35%)",
        color: "hsl(115, 100%, 25%)",
      };
    case "LOADED":
      return {
        backgroundColor: "hsl(115, 100%, 75%)",
        borderColor: "hsl(115, 100%, 30%)",
        color: "hsl(115, 100%, 20%)",
      };
    case "DISPATCH_READY":
      return {
        backgroundColor: "hsl(40, 100%, 95%)",
        borderColor: "hsl(40, 100%, 45%)",
        color: "hsl(40, 100%, 35%)",
      };
    case "DISPATCHED":
      return {
        backgroundColor: "hsl(40, 100%, 90%)",
        borderColor: "hsl(40, 100%, 40%)",
        color: "hsl(40, 100%, 30%)",
      };
    case "BOARDED":
      return {
        backgroundColor: "hsl(40, 100%, 85%)",
        borderColor: "hsl(40, 100%, 35%)",
        color: "hsl(40, 100%, 25%)",
      };
    case "RECEIVED":
      return {
        backgroundColor: "hsl(40, 100%, 80%)",
        borderColor: "hsl(40, 100%, 30%)",
        color: "hsl(40, 100%, 20%)",
      };
    case "UNLOADED":
      return {
        backgroundColor: "hsl(40, 100%, 75%)",
        borderColor: "hsl(40, 100%, 25%)",
        color: "hsl(40, 100%, 15%)",
      };
    case "DELIVERY_IN_PROGRESS":
    case "IN_PROGRESS":
      return {
        backgroundColor: "hsl(30, 100%, 90%)",
        borderColor: "hsl(30, 100%, 50%)",
        color: "hsl(30, 100%, 40%)",
      };
    case "HANDED_OVER":
      return {
        backgroundColor: "hsl(40, 100%, 85%)",
        borderColor: "hsl(40, 100%, 45%)",
        color: "hsl(40, 100%, 35%)",
      };
    case "OPEN":
    case "IDLE":
    case "PLANNED":
    case "WAITING":
      return {
        backgroundColor: "hsl(0, 0%, 95%)",
        borderColor: "hsl(0, 0%, 40%)",
        color: "hsl(0, 0%, 30%)",
      };
    case "CLOSED":
      return {
        backgroundColor: "hsl(0, 0%, 90%)",
        borderColor: "hsl(0, 0%, 60%)",
        color: "hsl(0, 0%, 50%)",
      };
    case "NO_SHOW":
      return {
        backgroundColor: "hsl(0, 0%, 85%)",
        borderColor: "hsl(0, 0%, 55%)",
        color: "hsl(0, 0%, 45%)",
      };
    case "DELIVERY_NOT_POSSIBLE":
      return {
        backgroundColor: "hsl(0, 0%, 80%)",
        borderColor: "hsl(0, 0%, 50%)",
        color: "hsl(0, 0%, 40%)",
      };
    case "DELIVERY_REFUSED":
      return {
        backgroundColor: "hsl(0, 0%, 70%)",
        borderColor: "hsl(0, 0%, 30%)",
        color: "hsl(0, 0%, 20%)",
      };
    case "RETURNED":
      return {
        backgroundColor: "hsl(0, 0%, 60%)",
        borderColor: "hsl(0, 0%, 90%)",
        color: "hsl(0, 0%, 100%)",
      };
    case "CANCELLED":
      return {
        backgroundColor: "hsl(0, 0%, 40%)",
        borderColor: "hsl(0, 0%, 90%)",
        color: "hsl(0, 0%, 100%)",
      };
    case "PENDING_CONFIRMATION":
      return {
        backgroundColor: "hsl(25, 100%, 90%)",
        borderColor: "hsl(25, 100%, 35%)",
        color: "hsl(25, 100%, 25%)",
      };
    case "PENDING_REVIEW":
      return {
        backgroundColor: "hsl(25, 100%, 80%)",
        borderColor: "hsl(25, 100%, 35%)",
        color: "hsl(25, 100%, 25%)",
      };
    case "REJECTED":
      return {
        backgroundColor: "hsl(0, 100%, 90%)",
        borderColor: "hsl(0, 100%, 35%)",
        color: "hsl(0, 100%, 25%)",
      };
    default:
  }
};
